import request from '@/utils/request'

const getDashboard = () => {
  return request({
    url: `/api/dashboards`,
    method: 'get'
  })
}

export default {
  getDashboard
}
